import { AiFillHeart } from 'react-icons/ai'
import { Link } from 'react-router-dom'

import styled, { css } from 'styled-components'

export const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  background: #f7f7f6;
  color: #202020;
  font-family: 'Baloo 2';
`

export const Image = styled.div<{ cover?: string }>`
  background-image: url(${(props) => props.cover});
  width: 50px;
  height: 50px;
  background-size: contain;
  border-radius: 50%;
  margin-right: 20px;
  margin-left: 20px;
`

export const List = styled.div`
  width: 100%;
  flex-grow: 1;
  max-height: 500px;
  overflow-y: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

export const Line = styled.div<{ fullWidth?: boolean }>`
  ${(props) =>
    props.fullWidth &&
    css`
      width: 100%;
    `}
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: row;
`

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
`

export const Title = styled.h4`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const Content = styled.div`
  width: min(1240px, calc(100% - 36px));
  display: flex;
  align-items: stretch;
  flex-direction: column;
  gap: 18px;
  min-height: 300px;
  margin: 20px auto 48px;
`

export const Heart = styled(AiFillHeart)`
  cursor: pointer;
  transition:
    color 200ms ease,
    background 200ms ease,
    transform 160ms ease;

  @media (max-width: 948px) {
    flex: 0 0 42px;
    width: 42px;
    height: 42px;
    padding: 9px;
    border: 1px solid #f0dddd;
    border-radius: 50%;
    background: #fff7f7;
    box-sizing: border-box;

    &:active {
      transform: scale(0.96);
    }
  }
`
type HeaderProps = { cover?: string }

export const Header = styled.div<HeaderProps>`
  background-image: url(${({ cover }) =>
    cover && cover !== ''
      ? cover
      : '/images/desktop/home/redsterna_gray_logo.png'});
  background-size: ${({ cover }) => (cover ? 'cover' : '')};
  background-repeat: no-repeat;
  background-position: center;

  width: min(1240px, calc(100% - 36px));
  min-height: 300px;
  margin-top: 88px;
  border-radius: 18px;
  overflow: hidden;

  color: white;
  font-size: 30px;
  font-weight: bold;

  display: flex;
  justify-content: center;
  align-items: center;
`

export const ItineraryHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 22px;
  width: 100%;
  padding: 20px 22px;
  border: 1px solid #ebebeb;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.05);

  @media (max-width: 760px) {
    align-items: flex-start;
    flex-direction: column;
  }
`

export const HeaderIcon = styled.img`
  width: 50px;
  height: 50px;
  margin-right: 10px;
`

export const HeaderRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: fit-content;
`

export const Icons = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;

  width: fit-content;

  @media (max-width: 948px) {
    width: 100%;
    justify-content: space-between;
    gap: 8px;
    flex-direction: row;
    flex-wrap: nowrap;
  }
`

export const InspireButton = styled.button`
  min-height: 42px;
  padding: 0 17px;
  border: 1px solid #e00000;
  border-radius: 999px;
  background: #e00000;
  color: #fff;
  font-family: inherit;
  font-size: 12px;
  font-weight: 800;
  cursor: pointer;
  box-shadow: 0 7px 18px rgba(224, 0, 0, 0.18);
  transition:
    transform 160ms ease,
    box-shadow 160ms ease,
    background 160ms ease;

  &:hover {
    transform: translateY(-1px);
    background: #c80000;
    box-shadow: 0 10px 22px rgba(200, 0, 0, 0.23);
  }

  @media (max-width: 948px) {
    flex: 1 1 auto;
    min-width: 0;
    min-height: 42px;
    padding: 0 12px;
    font-size: 10px;
    white-space: nowrap;
  }

  @media (max-width: 380px) {
    padding: 0 9px;
    font-size: 9px;
  }
`

export const OwnerActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  @media (max-width: 948px) {
    width: 100%;
    flex-direction: column;
  }
`

export const OwnerActionButton = styled.button<{ $danger?: boolean }>`
  min-height: 40px;
  padding: 0 14px;
  border: 1px solid ${({ $danger }) => ($danger ? '#e2b9b9' : '#dedede')};
  border-radius: 999px;
  background: ${({ $danger }) => ($danger ? '#fff7f7' : '#fff')};
  color: ${({ $danger }) => ($danger ? '#c80000' : '#444')};
  font-family: inherit;
  font-size: 11px;
  font-weight: 800;
  cursor: pointer;
  transition:
    transform 160ms ease,
    border-color 160ms ease,
    background 160ms ease;

  &:hover:not(:disabled) {
    transform: translateY(-1px);
    border-color: ${({ $danger }) => ($danger ? '#c80000' : '#bcbcbc')};
    background: ${({ $danger }) => ($danger ? '#fff0f0' : '#f8f8f8')};
  }

  &:disabled {
    cursor: wait;
    opacity: 0.65;
  }

  @media (max-width: 948px) {
    width: 100%;
    min-height: 38px;
    padding: 0 13px;
    font-size: 10px;
  }
`

export const Tittle = styled.div`
  font-size: 24px;
  font-weight: 500;
  @media (max-width: 948px) {
    font-size: 18px;
  }
`

export const CollaborationTag = styled.span`
  display: inline-flex;
  align-items: center;
  min-height: 26px;
  margin: 5px 0 3px;
  padding: 0 10px;
  border-radius: 999px;
  background: #fff3f3;
  color: #c80000;
  font-size: 10px;
  font-weight: 800;
`

export const InspirationSource = styled.div`
  margin: 5px 0 2px;
  color: #777;
  font-size: 11px;
`

export const InspirationSourceLink = styled(Link)`
  color: #c80000;
  font-weight: 700;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`

export const AuthorName = styled(Link)``

export const InfosWrapper = styled.div`
  display: flex;
  width: 100%;
  gap: 10px;

  @media (max-width: 600px) {
    flex-direction: column;
  }
`

export const InfoCard = styled.div`
  display: flex;
  min-width: 180px;
  align-items: center;
  gap: 10px;
  padding: 12px 15px;
  border: 1px solid #ececec;
  border-radius: 13px;
  background: #fff;
`

export const InfoText = styled.div`
  color: #888;
  font-size: 10px;
  line-height: 1.2;
`

export const BoldText = styled.div`
  margin-top: 2px;
  color: #292929;
  font-size: 13px;
  font-weight: 700;
`

export const InfoIcon = styled.img`
  height: 35px;
  width: 35px;
  @media (max-width: 948px) {
    height: 25px;
    width: 25px;
  }
`

export const SummaryTitle = styled.div`
  font-size: 24px;
  margin: 0 10px 0 10px;
  font-weight: 400;
  text-align: center;

  & span:first-child {
    color: #373737;
  }

  & span:last-child {
    color: #c62a31;
  }
`

export const Summary = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 18px 20px;
  border: 1px solid #ececec;
  border-radius: 16px;
  background: #fff;
`

export const DescriptionCard = styled.div`
  width: 100%;
  padding-top: 8px;
  color: #666;
  font-size: 13px;
  line-height: 1.6;
`

export const CheckInTittle = styled.div`
  display: flex;
  background: #ffffff;
  box-shadow: -3px 4px 14px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 20px;
  height: auto;
  margin-top: 40px;
`

export const CityCard = styled.div`
  display: flex;
  box-shadow: -3px 4px 14px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  width: fit-content;
  background-color: #ffffff;
  font-weight: 400;
  font-size: 20px;
  align-items: center;
  padding: 5px;
  justify-content: space-around;
  border-left: 10px solid #c62a31;
  align-self: flex-start;
  margin-top: 40px;
`

export const CityIcon = styled.img`
  width: 35px;
  height: 35px;
  margin-right: 10px;
`

export const HotelCard = styled.div`
  display: flex;
  box-shadow: -3px 4px 14px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  width: fit-content;
  background-color: #ffffff;
  font-weight: 400;
  font-size: 20px;
  align-items: center;
  padding: 5px;
  justify-content: flex-start;
  align-self: flex-start;
  margin: 10px auto 0 0;
  border: 1px solid #e0e0e0;
`
export const HotelName = styled.div`
  font-size: 20px;
  margin-left: 10px;
  margin-right: 10px;
  font-weight: 400;
`

export const SummaryDescription = styled.div`
  width: 95%;
  border-radius: 15px;
  border: 1px solid #e0e0e0;
  height: auto;
  max-height: 180px;
  overflow-y: auto;
  padding: 16px 24px;
  margin-top: 20px;
  color: #454545;

  @media (max-width: 700px) {
    width: 100%;
    max-height: 220px;
    padding: 14px 16px;
  }
`

export const DescriptionText = styled.div`
  width: 100%;
  line-height: 1.55;
  text-align: left;
  white-space: pre-line;
`

export const Photos = styled.img`
  width: 220px;
  height: 150px;
  object-fit: cover;
  border-radius: 10px;
  display: block;
  transition:
    transform 160ms ease,
    box-shadow 160ms ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 18px rgba(0, 0, 0, 0.16);
  }

  @media (max-width: 700px) {
    width: 100%;
    height: auto;
    aspect-ratio: 1 / 1;
    border-radius: 8px;
  }
`

export const Row = styled.div`
  display: flex;
  width: 85%;
  align-items: center;
  justify-content: flex-end;
`

export const ImageContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 12px;
  margin: 16px 0 24px;
  padding: 0 24px;
  width: 100%;

  @media (max-width: 700px) {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    padding: 0;
    gap: 6px;
    justify-content: stretch;
    margin: 14px 0 18px;
  }
`

export const ImageColumn = styled.div`
  display: flex;
  flex-direction: column;
`
export const ImageWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  flex-direction: column;

  @media (max-width: 640px) {
    margin-right: 0;
  }
`

export const LightboxButton = styled.button`
  height: fit-content;
  background: transparent;
  border: none;
  width: fit-content;
  padding: 0;
  border-radius: 10px;
  cursor: zoom-in;

  @media (max-width: 700px) {
    width: 100%;
    border-radius: 8px;
  }
`

export const LightboxWrapper = styled.div`
  background: unset;
  border: none;
  height: auto;
  width: auto;

  @media (max-width: 700px) {
    width: 100%;
    min-width: 0;
  }
`

export const LightboxOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(0, 0, 0, 0.9);
`

export const LightboxDialog = styled.div`
  position: relative;
  width: min(94vw, 1400px);
  height: min(92vh, 1000px);
  display: flex;
  align-items: center;
  justify-content: center;
`

export const LightboxImage = styled.img`
  max-width: 100%;
  max-height: 88vh;
  width: auto;
  height: auto;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.35);
`

export const LightboxClose = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  z-index: 3;
  width: 44px;
  height: 44px;
  border: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.95);
  color: #222;
  font-size: 32px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const LightboxArrow = styled.button<{ $side: 'left' | 'right' }>`
  position: absolute;
  top: 50%;
  ${({ $side }) => $side}: 8px;
  transform: translateY(-50%);
  z-index: 3;
  width: 48px;
  height: 58px;
  border: 0;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.9);
  color: #222;
  font-size: 40px;
  line-height: 1;
  cursor: pointer;
`

export const LightboxCounter = styled.div`
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  padding: 6px 12px;
  border-radius: 16px;
  background: rgba(0, 0, 0, 0.65);
  color: white;
  font-size: 14px;
`

export const InspirationOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 10020;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(20, 20, 20, 0.5);
  backdrop-filter: blur(4px);
`

export const InspirationDialog = styled.div`
  width: min(640px, 100%);
  max-height: min(780px, calc(100vh - 40px));
  overflow-y: auto;
  padding: 28px;
  border-radius: 20px;
  background: #fff;
  box-shadow: 0 24px 70px rgba(0, 0, 0, 0.22);

  h2 {
    margin: 5px 0 10px;
    color: #232323;
    font-size: 25px;
    line-height: 1.15;
  }

  p {
    margin: 0;
    color: #666;
    font-size: 13px;
    line-height: 1.6;
  }
`

export const InspirationEyebrow = styled.span`
  color: #d60000;
  font-size: 10px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.08em;
`

export const InspirationIntro = styled.p`
  margin: 0;
  color: #666;
  font-size: 13px;
  line-height: 1.6;
`

export const PrototypeNotice = styled.div`
  margin-top: 16px;
  padding: 11px 13px;
  border: 1px solid #f1d9a6;
  border-radius: 12px;
  background: #fff9ec;
  color: #7b6230;
  font-size: 10px;
  line-height: 1.5;
`

export const InspirationForm = styled.div`
  display: grid;
  gap: 18px;
  margin-top: 20px;

  label {
    display: grid;
    gap: 6px;
  }

  label > strong {
    color: #30343a;
    font-size: 12px;
  }

  label > span {
    color: #8a8f98;
    font-size: 10px;
    line-height: 1.45;
  }

  textarea {
    width: 100%;
    min-height: 92px;
    resize: vertical;
    padding: 12px 13px;
    border: 1px solid #dedfe2;
    border-radius: 12px;
    outline: none;
    color: #31343a;
    font-family: inherit;
    font-size: 12px;
    line-height: 1.5;

    &:focus {
      border-color: #e00000;
      box-shadow: 0 0 0 3px rgba(224, 0, 0, 0.07);
    }
  }
`

export const InspirationCounter = styled.small`
  justify-self: end;
  margin-top: -2px;
  color: #9a9fa8;
  font-size: 9px;
`

export const InspirationChoiceGroup = styled.div`
  display: grid;
  gap: 8px;

  > strong {
    color: #30343a;
    font-size: 12px;
  }
`

export const InspirationChoiceRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 7px;

  button {
    min-height: 34px;
    padding: 0 12px;
    border: 1px solid #dedfe2;
    border-radius: 999px;
    background: #fff;
    color: #666;
    font-family: inherit;
    font-size: 10px;
    font-weight: 700;
    cursor: pointer;
  }

  button.selected {
    border-color: #e00000;
    background: #fff2f2;
    color: #c80000;
  }
`

export const InspirationErrorState = styled.div`
  padding: 12px 4px 4px;
  text-align: center;

  h2 {
    margin: 10px 0 7px;
  }

  p {
    max-width: 500px;
    margin: 0 auto;
    color: #555b64;
    font-size: 12px;
    line-height: 1.55;
  }

  > span {
    display: block;
    max-width: 500px;
    margin: 8px auto 0;
    color: #8a9099;
    font-size: 10px;
    line-height: 1.45;
  }
`

export const InspirationProcessing = styled.div`
  padding: 18px 4px 6px;
  text-align: center;

  h2 {
    margin-top: 9px;
  }

  p {
    max-width: 470px;
    margin: 0 auto;
  }
`

export const InspirationProgress = styled.div`
  position: relative;
  width: min(360px, 88%);
  height: 8px;
  margin: 28px auto 0;
  overflow: visible;
  border-radius: 999px;
  background: #f0f1f3;

  > span {
    position: absolute;
    inset: 0 auto 0 0;
    min-width: 6%;
    border-radius: inherit;
    background: #e00000;
    transition: width 0.55s ease;
  }

  img {
    position: absolute;
    top: 50%;
    width: 30px;
    height: 30px;
    object-fit: contain;
    transform: translate(-50%, -50%);
    transition: left 0.55s ease;
    filter: drop-shadow(0 3px 7px rgba(0, 0, 0, 0.15));
  }
`

export const InspirationProgressMeta = styled.div`
  width: min(360px, 88%);
  margin: 9px auto 0;
  display: flex;
  justify-content: space-between;
  gap: 12px;
  color: #9a9fa8;

  span {
    color: #e00000;
    font-size: 10px;
    font-weight: 800;
  }

  small {
    font-size: 10px;
    text-align: right;
  }
`

export const InspirationResultCard = styled.div`
  margin-top: 18px;
  padding: 17px;
  border: 1px solid #e8e9ec;
  border-radius: 15px;
  background: #fafbfc;

  > small,
  > strong {
    display: block;
  }

  > small {
    color: #979ca5;
    font-size: 9px;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.06em;
  }

  > strong {
    margin-top: 5px;
    color: #282d34;
    font-size: 14px;
    line-height: 1.4;
  }
`

export const InspirationResultMeta = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 13px;

  span {
    padding: 5px 8px;
    border-radius: 999px;
    background: #fff;
    color: #747b85;
    font-size: 9px;
    font-weight: 700;
  }
`

export const InspirationTagList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  margin-top: 12px;

  span {
    padding: 6px 9px;
    border-radius: 999px;
    background: #fff0f0;
    color: #c80000;
    font-size: 9px;
    font-weight: 800;
  }
`

export const StructureOptions = styled.div`
  display: grid;
  gap: 10px;
  margin-top: 20px;

  button {
    width: 100%;
    padding: 14px 15px;
    border: 1px solid #e3e5e8;
    border-radius: 13px;
    background: #fff;
    text-align: left;
    cursor: pointer;
    transition:
      border-color 0.18s ease,
      background 0.18s ease,
      box-shadow 0.18s ease;
  }

  button.selected {
    border-color: #e00000;
    background: #fff7f7;
    box-shadow: 0 0 0 3px rgba(224, 0, 0, 0.06);
  }

  strong,
  span {
    display: block;
  }

  strong {
    color: #2e333a;
    font-size: 12px;
  }

  span {
    margin-top: 4px;
    color: #7f8792;
    font-size: 10px;
    line-height: 1.5;
  }
`

export const StructureChanges = styled.div`
  display: grid;
  gap: 7px;
  margin-top: 18px;
  padding: 12px 14px;
  border-radius: 12px;
  background: #f7f8f9;

  span {
    color: #646b75;
    font-size: 10px;
    line-height: 1.45;
  }
`

export const StructurePlanList = styled.div`
  display: grid;
  gap: 8px;
  margin-top: 14px;

  > div {
    display: grid;
    grid-template-columns: 58px 1fr;
    gap: 3px 10px;
    align-items: center;
    padding: 11px 12px;
    border: 1px solid #e7e8eb;
    border-radius: 12px;
    background: #fff;
  }

  strong {
    color: #e00000;
    font-size: 10px;
    text-transform: uppercase;
    letter-spacing: 0.03em;
  }

  span {
    color: #30343a;
    font-size: 11px;
    font-weight: 800;
  }

  small {
    grid-column: 2;
    color: #8a9099;
    font-size: 9px;
    line-height: 1.4;
  }

  @media (max-width: 520px) {
    > div {
      grid-template-columns: 1fr;
    }

    small {
      grid-column: 1;
    }
  }
`

export const StructureConfirmation = styled.div`
  margin-top: 20px;
  padding: 17px;
  border: 1px solid #eadede;
  border-radius: 14px;
  background: #fffafa;

  strong,
  span {
    display: block;
  }

  strong {
    color: #292f36;
    font-size: 13px;
  }

  span {
    margin-top: 6px;
    color: #777f89;
    font-size: 10px;
    line-height: 1.5;
  }
`

export const InspirationDraftNote = styled.p`
  margin: 14px 0 -10px;
  color: #8a9099;
  font-size: 10px;
  line-height: 1.45;
`

export const InspirationActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 9px;
  margin-top: 22px;

  button {
    min-height: 40px;
    padding: 0 15px;
    border: 1px solid #dedede;
    border-radius: 999px;
    background: #fff;
    color: #666;
    font-family: inherit;
    font-size: 11px;
    font-weight: 700;
    cursor: pointer;
  }

  button.primary {
    border-color: #e00000;
    background: #e00000;
    color: #fff;
  }

  button:disabled {
    cursor: wait;
    opacity: 0.65;
  }

  @media (max-width: 520px) {
    flex-direction: column-reverse;

    button {
      width: 100%;
    }
  }
`

export const ReadSection = styled.section`
  width: 100%;
  padding: 20px;
  border: 1px solid #ececec;
  border-radius: 18px;
  background: #fff;
`

export const ReadSectionHeading = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;

  > div {
    display: flex;
    flex-direction: column;
    gap: 3px;
  }

  strong {
    color: #242424;
    font-size: 18px;
  }

  span {
    color: #888;
    font-size: 11px;
  }
`

export const ReadCityCard = styled.article`
  width: 100%;
  padding: 16px;
  border: 1px solid #ededed;
  border-radius: 14px;
  background: #fff;

  & + & {
    margin-top: 12px;
  }
`

export const ReadCityHeader = styled.div`
  display: flex;
  align-items: baseline;
  gap: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #f0f0f0;

  span {
    color: #d80000;
    font-size: 10px;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.04em;
  }

  strong {
    color: #222;
    font-size: 17px;
  }
`

export const ReadDays = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const ReadDayCard = styled.article`
  border: 1px solid #e9e9e9;
  border-radius: 15px;
  overflow: hidden;
  background: #fff;
`

export const ReadDayHeader = styled.div`
  min-height: 50px;
  padding: 10px 14px;
  border-bottom: 1px solid #eeeeee;
  display: flex;
  align-items: center;
  gap: 12px;
  background: #fcfcfc;

  > strong {
    color: #333;
    font-size: 12px;
    font-weight: 700;
  }

  @media (max-width: 640px) {
    align-items: flex-start;
    flex-direction: column;
    gap: 5px;
  }
`

export const ReadDayNumber = styled.span`
  color: #1f1f1f;
  font-size: 13px;
  font-weight: 800;
`

export const ReadDayDate = styled.span`
  min-height: 26px;
  padding: 0 9px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  background: #f1f1f1;
  color: #666;
  font-size: 9px;
  font-weight: 700;
`

export const ReadDayCities = styled.div`
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const EmptyDay = styled.div`
  padding: 18px 12px;
  color: #999;
  font-size: 10px;
  text-align: center;
`
